import { render, staticRenderFns } from "./TagSelector.vue?vue&type=template&id=2f0ab1ce&scoped=true&"
import script from "./TagSelector.vue?vue&type=script&lang=js&"
export * from "./TagSelector.vue?vue&type=script&lang=js&"
import style0 from "./TagSelector.vue?vue&type=style&index=0&id=2f0ab1ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0ab1ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/timefly-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f0ab1ce')) {
      api.createRecord('2f0ab1ce', component.options)
    } else {
      api.reload('2f0ab1ce', component.options)
    }
    module.hot.accept("./TagSelector.vue?vue&type=template&id=2f0ab1ce&scoped=true&", function () {
      api.rerender('2f0ab1ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TagSelector.vue"
export default component.exports